"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ruleEvaluationResults = void 0;
exports.ruleEvaluationResults = [
    {
        dmn_decision_version: 1,
        dmn_decision_name: "Pre-Prediction Rules",
        dmn_decision_key: "pre_prediction_rules",
        dmn_decision_version_tag: 1,
        bpmn_activity_id: "EndPrePredictionRulesSubprocess",
        inputs: {
            input: "{case_data={stop_light_indicator=green, result_status=F, point_of_care=null, date_of_service=2020-03-18, exam_code=MG.BI.SCTMCD/B}, config_data={end_date=2999-12-31, provider_exclusions=null, go_live_date=2020-01-01, max_age_in_days=180, exam_code_exclusions=null, point_of_care_exclusions=null}}"
        },
        matched_rules: []
    },
    {
        dmn_decision_version: 1,
        dmn_decision_name: "Decorate StopLight Rules",
        dmn_decision_key: "decorate_stoplight",
        dmn_decision_version_tag: 1,
        bpmn_activity_id: "RunSystemDecorationRulesServiceTask",
        inputs: {
            input: "{case_data={procedure_type_category=null}}"
        },
        matched_rules: []
    }
];
//# sourceMappingURL=rule-evaluation-results.js.map